module.exports = __webpack_public_path__ + "img/podium_6095.03c68283.jpg";